/*eslint-disable*/
import { useEffect, useRef } from 'react'

export function useInterval(callback: any, delay: number | null) {
    const savedCallback = useRef<Function | undefined>()

    // Remember the latest callback.
    useEffect(() => {
        savedCallback.current = callback
    }, [callback])

    // Set up the interval.
    useEffect(() => {
        function tick() {
            savedCallback.current ? savedCallback.current() : null
        }
        if (delay !== null) {
            let id = setInterval(tick, delay)
            return () => clearInterval(id)
        } else {
            return undefined
        }
    }, [delay])
}
